export enum SlownikRodzaj {
  TERYT_GMINY = 'TERYT_GMINY',
  TERYT_MIEJSCOWOSCI = 'TERYT_MIEJSCOWOSCI',
  TERYT_ULICE = 'TERYT_ULICE',
  PANSTWA = 'PANSTWA',
  SL_OBSZARY_ZS = 'SL_OBSZARY_ZS',
  T_SPANSTW_OBYWATELSTW_PL = 'T_SPANSTW_OBYWATELSTW_PL',
  SL_RODZAJ_SZKOLY_DSR = 'SL_RODZAJ_SZKOLY_DSR',
  PANSTWA_SWR = 'PANSTWA_SWR',
}
